/**
 * Shared recharts theming for the Google Analytics charts.
 *
 * The categorical series colours were validated as a set against the card surface (#f2f3ff) for
 * colour-vision deficiency separation, the normal-vision floor and 3:1 contrast — all pairs, not
 * just adjacent ones. Do not substitute a hue without re-validating: the three are chosen to stay
 * distinguishable together, not in isolation.
 */

export const sharedAxisProps = {
  tick: { fill: "var(--color-on-surface-variant, #434656)", fontSize: 11 },
  tickLine: false,
  axisLine: false,
};

export const sharedTooltipProps = {
  contentStyle: {
    background: "var(--color-surface-container-lowest, #ffffff)",
    border: "1px solid #c4c5d9",
    borderRadius: 12,
    fontSize: 12,
  },
  labelStyle: { color: "var(--color-on-surface-variant, #434656)" },
};

export const SERIES_COLORS = {
  sessions: "#2E5BFF",
  users: "#008300",
  pageviews: "#4a3aa7",
};

/** Single-hue colour for charts showing one measure, where identity needs no encoding. */
export const SINGLE_SERIES_COLOR = "#2E5BFF";
